<!--
 * @Description:
 * @Date: 2022-02-25 10:28:33
-->
<template>
  <el-dialog
    title="修改活动名称"
    :visible="true"
    width="600px"
    :before-close="() => $emit('remove')"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      :model="form"
      label-position="right"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item label="活动名称" prop="activityName" ref="activityName">
        <el-input
          v-model="form.activityName"
          placeholder="最多输入50个字"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('remove')">取 消</el-button>
      <el-button type="primary" @click="confirm" :loading="loading">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { activity } from '@/api/ajax';

export default {
  props: ['activityName', 'serviceActivityId'],
  name: 'active-update',
  data: () => ({
    rules: {
      activityName: [{ required: true, message: '活动名称不能为空' }]
    },
    form: {
      activityName: ''
    },
    loading: false
  }),
  methods: {
    async confirm() {
      // 本地验证表单内容
      await this.$refs.form.validate();

      try {
        // 远程校验 调用接口
        this.loading = true;
        await activity.update({
          activityName: this.form.activityName,
          serviceActivityId: this.serviceActivityId
        });

        // 远程验证 成功
        this.$message.success('更新成功');
        this.$emit('confirm');
        this.$emit('remove');
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    }
  },
  created() {
    this.form.activityName = this.activityName.slice(0, 50);
  }
};
</script>

<style scoped>
/deep/ .el-input__inner {
  padding: 5px 50px 5px 15px !important;
}
</style>
